import { mergeRight } from 'ramda';

import { TMappedAnswersState } from '../types';
import { getMessageSource } from '../../../utils/getMessageSource';
import { EMortgageBankApprove } from '../../../repositories/demand/entities/public_v5_create_message/RequestMessageV5Schema';
import { IParsedQsParams } from '../../../types/qsParams/expectedQsParams';
import { TCreateMessageRequest } from '../../../repositories/demand/v5/create-message';
import { TCreatePersonalMessageRequest } from '../../../repositories/demand/v2/create-personal-message';

interface IParams {
  mappedAnswersState: TMappedAnswersState;
  isWebview: boolean;
  platform: string | null;
  queryParams: IParsedQsParams;
}

const params = {
  isBankDeposit: false,
  isHasOffer: false,
  isMortgageInitialPayment: false,
  isReadyToLower: false,
  mortgageBankApprove: EMortgageBankApprove.No,
};

const DEFAULT_SOURCE = 'request-form-realtor';
const DEFAULT_PERSONAL_SOURCE = 'personal-request-form-realtor';

/** Добавляет обязательные значения по умолчанию */
export const createRequestPayload = ({
  mappedAnswersState,
  isWebview,
  platform,
  queryParams,
}: IParams): TCreateMessageRequest => {
  const source = getMessageSource({ isWebview, platform, queryParams, defaultSource: DEFAULT_SOURCE });

  return mergeRight(
    {
      ...params,
      source,
    },
    mappedAnswersState,
  ) as TCreateMessageRequest;
};

/** Добавляет обязательные значения по умолчанию для персональной заявки */
export const createRequestPayloadForPersonal = ({
  platform,
  isWebview,
  mappedAnswersState,
  queryParams,
}: IParams): TCreatePersonalMessageRequest => {
  const specialistIds = mappedAnswersState.realtorListing.map(item => Number(item));

  const source = getMessageSource({
    isWebview,
    platform,
    queryParams,
    defaultSource: DEFAULT_PERSONAL_SOURCE,
  });

  return mergeRight(
    {
      ...params,
      source,
      specialistIds,
    },
    mappedAnswersState,
  ) as TCreatePersonalMessageRequest;
};
